import { render, staticRenderFns } from "./DirectiveLinePropertyEditor.vue?vue&type=template&id=270acfa1&scoped=true&"
import script from "./DirectiveLinePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./DirectiveLinePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270acfa1",
  null
  
)

export default component.exports